import { Chip, Tooltip } from '@mui/material';
import { Box } from '@mui/material';
import { ReactElement, ReactNode } from 'react';

/**
 * What a person is in this house — main contact, bonus contact, import
 * contact — as a pill right behind the name.
 *
 * It used to be written under the name, which gave every row of the employee
 * tables three or four lines and broke the one-line list (LST-S3). The first
 * function is shown and the rest counted, so a row stays one line however many
 * a person carries (LST-S3a).
 */
export interface PaloRolePillsProps {
    roles: ReactNode[];
}

export const PaloRolePills = ({ roles }: PaloRolePillsProps): ReactElement | null => {
    const [first, ...rest] = roles.filter(Boolean);

    if (undefined === first) {
        return null;
    }

    return (
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: '4px', flexShrink: 0 }}>
            <PaloRolePill label={first} />
            {rest.length > 0 && (
                <Tooltip
                    title={
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            {rest.map((role, index) => (
                                <span key={index}>{role}</span>
                            ))}
                        </Box>
                    }
                >
                    <Box component="span" sx={{ display: 'inline-flex' }}>
                        <PaloRolePill label={`+${rest.length}`} />
                    </Box>
                </Tooltip>
            )}
        </Box>
    );
};

const PaloRolePill = ({ label }: { label: ReactNode }): ReactElement => (
    <Chip
        size="small"
        label={label}
        // The dot the theme puts before a chip label belongs to the status
        // scale; a function is not a state and must not read as one.
        sx={{ '& .MuiChip-label::before': { display: 'none' } }}
    />
);
